import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const API_URL = "https://wip.technicalcreatives.lk/api/users.php";

const Register = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    re_password: "",
  });

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d@$!%*?&^#_~\-]{8,}$/;

  const passwordMismatch =
    form.re_password && form.password !== form.re_password;

  const isFormValid =
    form.firstName.trim() !== "" &&
    form.lastName.trim() !== "" &&
    form.email.trim() !== "" &&
    !emailError &&
    form.password.trim() !== "" &&
    !passwordError &&
    !passwordMismatch;

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isFormValid) return;

  try {
    const res = await axios.post(`${API_URL}?action=register`, {
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      password: form.password,
    });

    if (res.data.success || res.data.message === "User registered") {
      alert("Successfully Registered!");
      navigate("/");
    } else {
      alert(res.data.message || "Registration failed");
    }
  } catch (err) {
    console.error(err);
    alert("Server error. Registration failed.");
  }
};


  return (
    <div className="min-h-screen flex">
      {/* Left - Register form */}
      <div className="w-full md:w-1/2 flex items-center justify-center bg-white px-8 py-16">
        <div className="max-w-md w-full">
          <div className="mb-8">
            <img src="/images/logo.jpg" alt="Logo" className="h-20 mb-4" />
            <h2 className="text-3xl font-bold text-gray-900">Register</h2>
            <p className="text-sm text-gray-500 mt-2">
              Kindly fill this form to register.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="flex gap-4">
              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700">First Name</label>
                <input
                  placeholder="Your first name"
                  onChange={(e) => setForm({ ...form, firstName: e.target.value })}
                  className="w-full px-4 py-2 mt-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div className="w-1/2">
                <label className="block text-sm font-medium text-gray-700">Last Name</label>
                <input
                  placeholder="Your last name"
                  onChange={(e) => setForm({ ...form, lastName: e.target.value })}
                  className="w-full px-4 py-2 mt-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Email Address</label>
              <input
                placeholder="Enter email"
                onChange={(e) => {
                  const value = e.target.value;
                  setForm({ ...form, email: value });
                  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
                  setEmailError(isValidEmail || value === "" ? "" : "Invalid email address");
                }}
                className="w-full px-4 py-2 mt-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              {emailError && <p className="text-red-500 text-sm mt-1">{emailError}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Password</label>
              <div className="relative">
                <input
                  type={visible ? "text" : "password"}
                  placeholder="Password"
                  onChange={(e) => {
                    const value = e.target.value;
                    setForm({ ...form, password: value });
                    setPasswordError(
                      passwordRegex.test(value) || value === ""
                        ? ""
                        : "Password must be at least 8 characters, with letters, numbers, and symbols."
                    );
                  }}
                  className={`w-full px-4 py-2 mt-1 border ${
                    passwordError ? "border-red-500" : "border-gray-300"
                  } rounded focus:outline-none focus:ring-2 ${
                    passwordError ? "focus:ring-red-500" : "focus:ring-blue-500"
                  }`}
                  required
                />
                <button
                  type="button"
                  onClick={() => setVisible(!visible)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                >
                  {visible ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
              {passwordError && <p className="text-red-500 text-sm mt-1">{passwordError}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Repeat Password</label>
              <input
                type="password"
                placeholder="Repeat password"
                value={form.re_password}
                onChange={(e) => setForm({ ...form, re_password: e.target.value })}
                className={`w-full px-4 py-2 mt-1 border ${
                  passwordMismatch ? "border-red-500" : "border-gray-300"
                } rounded focus:outline-none focus:ring-2 ${
                  passwordMismatch ? "focus:ring-red-500" : "focus:ring-blue-500"
                }`}
                required
              />
              {passwordMismatch && <p className="text-red-500 text-sm mt-1">Passwords do not match.</p>}
            </div>

            <button
              type="submit"
              disabled={!isFormValid}
              className={`w-full text-white py-2 rounded transition ${
                !isFormValid ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              Sign up
            </button>
          </form>

          <p className="text-sm text-center text-gray-600 mt-4">
            Already have an account?{" "}
            <a href="/" className="text-blue-600 hover:underline">
              Login
            </a>
          </p>
        </div>
      </div>

      {/* Right - Illustration */}
      <div className="hidden md:block w-1/2 bg-blue-100 relative">
        <img
          src="/images/task.png"
          alt="login"
          className="absolute top-1/2 left-1/2 object-cover w-[500px] h-[500px] transform -translate-x-1/2 -translate-y-1/2"
        />
      </div>
    </div>
  );
};

export default Register;
